import React from 'react'
import {FormattedMessage} from 'react-intl'

import CheckBox from './CheckBox'
import Icon from './Icon'

const Options = ({query, show, onToggleMoreOptions, onChange}) => {
  const {options} = query
  const {moreOptions} = show
  return <div style={{display: 'flex', flexDirection: 'column'}} className="more-options">
    <div style={{display:'flex'}}>
      <div style={{display:'flex', flexDirection:'column', flexBasis:'33%' }}>
        <CheckBox value={options.garage} onChange={onChange(['options', 'garage'])}>
          <FormattedMessage id="Garage" defaultMessage="Garage"/>
        </CheckBox>

        <CheckBox label="Swimming pool" value={options.swimmingPool} onChange={onChange(['options', 'swimmingPool'])}>
          <FormattedMessage id="Swimming pool" defaultMessage="Swimming pool"/>
        </CheckBox>

      </div>
      <div style={{display:'flex', flexDirection:'column', flexBasis:'33%'}}>
        <CheckBox value={options.garden} onChange={onChange(['options', 'garden'])}>
          <FormattedMessage id="Garden" defaultMessage="Garden"/>
        </CheckBox>

        <CheckBox value={options.terrace} onChange={onChange(['options', 'terrace'])}>
          <FormattedMessage id="Terrace" defaultMessage="Terrace"/>
        </CheckBox>


      </div>
      <div style={{display:'flex', flexDirection:'column', flexBasis:'33%' }}>

        <CheckBox value={options.newOnly} onChange={onChange(['options', 'newOnly'])}>
          <FormattedMessage id="New only" defaultMessage="New only"/>
        </CheckBox>

        <CheckBox value={options.likedOnly} onChange={onChange(['options', 'likedOnly'])}>
          <Icon name="heart"></Icon>
          <FormattedMessage id="Liked only" defaultMessage="Liked only"/>
        </CheckBox>

      </div>
    </div>
</div>
}

Options.propTypes = {
  query: React.PropTypes.shape({
    options: React.PropTypes.shape({
      garage: React.PropTypes.bool.isRequired,
      swimmingPool: React.PropTypes.bool.isRequired,
      garden: React.PropTypes.bool.isRequired,
      terrace: React.PropTypes.bool.isRequired,
      newOnly: React.PropTypes.bool.isRequired,
      likedOnly: React.PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  show: React.PropTypes.shape({
    moreOptions: React.PropTypes.bool.isRequired,
  }),
  onToggleMoreOptions: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
}

export default Options



/** WEBPACK FOOTER **
 ** ./app/components/Options.jsx
 **/